// Les liens que le corps de chaque page porte déjà — lot 16, point 4.
//
// Lus dans src/data/liens-corps.json, GÉNÉRÉ au build par
// scripts/collecter-liens-corps.mjs depuis le HTML réellement rendu de chaque
// route. Le pied de page les retire de sa colonne contextuelle : un lien deux
// fois sur la même page n'apporte rien.
//
// Pourquoi un JSON dans le bundle et non une lecture du DOM : le client
// re-rend la page (createRoot, pas d'hydratation). Lire le DOM depuis le
// pied de page serait un calcul côté client, qui produirait un second rendu
// différent du premier ; le JSON donne au client et au pré-rendu la même
// réponse, sans rien calculer.
//
// Une route absente du JSON — URL inconnue côté client, nouvelle route avant
// le premier build — n'a pas d'exclusion : la colonne se rend quand même, et
// le contrôle de build signale les doublons.
import donnees from './liens-corps.json';

const PAGES = (donnees as { pages: Record<string, string[]> }).pages;

/** Chemin normalisé : sans domaine, sans ancre, sans slash final. */
function normaliser(route: string): string {
  let c = route.replace(/^https?:\/\/[^/]+/, '').replace(/[#?].*$/, '');
  if (c.length > 1 && c.endsWith('/')) c = c.slice(0, -1);
  return c || '/';
}

/** Les liens internes du corps de la page, tels que collectés au dernier build. */
export function liensDuCorps(route: string): readonly string[] {
  return PAGES[normaliser(route)] ?? [];
}

/** Les routes couvertes par la collecte, pour les contrôles. */
export function routesCollectees(): readonly string[] {
  return Object.keys(PAGES);
}
